module.exports = __webpack_public_path__ + "media/src/assets/images/lps-sell_investment-0caa25c8ba9db455e136bd69ad254d25.png";